/* global axios */

import ApiClient from './ApiClient';

class InformationalBroadcastsAPI extends ApiClient {
  constructor() {
    super('informational_broadcasts', { accountScoped: true });
  }

  preview({ page = 1, perPage = 25 } = {}) {
    return axios.get(`${this.url}/preview`, {
      params: { page, per_page: perPage },
    });
  }

  estimate(data) {
    return axios.post(`${this.url}/estimate`, data);
  }
}

export default new InformationalBroadcastsAPI();
